// extracted by mini-css-extract-plugin
export default {"calendar_overview_wrapper":"CalendarOverview_calendar_overview_wrapper__uoEzc"};